import { Component, OnInit } from '@angular/core';
import { Params,Router,ActivatedRoute } from '@angular/router';
import { debug } from 'console';
import { ConfirmAccountModel } from 'src/app/models/login/login.model';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-confirm-account',
  templateUrl: './confirm-account.component.html',
  styleUrls: ['./confirm-account.component.css']
})
export class ConfirmAccountComponent implements OnInit {
  confirmAccounts: ConfirmAccountModel = new ConfirmAccountModel();
  token: string;
  Loader: boolean = false;
  confirmAccountLoader: boolean = false;
  cancelAccountLoader: boolean = false;
  errorMessage: string;

  constructor(private alertify:AlertifyService, private route: ActivatedRoute,private router: Router, private customerService:CustomerService) { 
    this.confirmAccounts = new ConfirmAccountModel();
  }

  ngOnInit() {
    this.Loader = true;
    this.cancelAccountLoader = false;
    this.confirmAccountLoader = false;
    this.route.params.subscribe((param) => {
      this.token = param['token'];
      this.confirmAccounts.Token = this.token;
      this.customerService.GetUserVerification(this.confirmAccounts)
      .subscribe((response) => {
        this.Loader = false;
        var responseBody = JSON.parse(response._body);
        if(responseBody.isSuccess) {
          this.confirmAccountLoader = true;
        } else {
          this.cancelAccountLoader = true;
          this.errorMessage = responseBody.responseMessage;
          return;
        }
    
    })
  }
    )
}
signUp() {
  this.router.navigate(['/login']);
}
}
